<template>
	<div class="loan_page">
		<!-- 电路板背景 -->
		<div class="circuit_background">
			<svg xmlns="http://www.w3.org/2000/svg">
				<defs>
					<pattern id="circuit" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
						<!-- 横向线路 -->
						<line x1="0" y1="50" x2="80" y2="50" stroke="#00d9ff" stroke-width="2"/>
						<line x1="120" y1="50" x2="200" y2="50" stroke="#00d9ff" stroke-width="2"/>
						<circle cx="80" cy="50" r="4" fill="#00d9ff"/>
						<circle cx="120" cy="50" r="4" fill="#00d9ff"/>
						
						<!-- 纵向线路 -->
						<line x1="50" y1="0" x2="50" y2="80" stroke="#00d9ff" stroke-width="2"/>
						<line x1="50" y1="120" x2="50" y2="200" stroke="#00d9ff" stroke-width="2"/>
						<circle cx="50" cy="80" r="4" fill="#00d9ff"/>
						<circle cx="50" cy="120" r="4" fill="#00d9ff"/>
						
						<!-- 斜向线路 -->
						<line x1="150" y1="0" x2="150" y2="150" stroke="#00d9ff" stroke-width="2"/>
						<line x1="150" y1="150" x2="200" y2="150" stroke="#00d9ff" stroke-width="2"/>
						<circle cx="150" cy="150" r="4" fill="#00d9ff"/>
						
						<!-- 额外节点 -->
						<circle cx="100" cy="100" r="6" fill="none" stroke="#00d9ff" stroke-width="2"/>
						<circle cx="100" cy="100" r="3" fill="#00d9ff"/>
					</pattern>
				</defs>
				<rect width="100%" height="100%" fill="url(#circuit)"/>
			</svg>
		</div>

		<!-- 内容区 -->
		<div class="loan_content">
		<!-- 头部 -->
			<header class="loan_header">
				<div class="header_left">
					<div class="back_btn" @click="goBack">
						<img src="../../assets/images/return-w.png" alt="">
					</div>
					<h1>{{$t('loan.loanTitle')}}</h1>
				</div>
				<div class="menu_btn" @click="showRecords = true">
					<div class="menu_icon">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</header>

			<!-- 利率信息卡片 -->
			<div class="rate_card">
				<div class="rate_item">
					<div class="rate_label">{{$t('loan.dailyRate')}}</div>
					<div class="rate_value">{{ config.daily_rate }}%</div>
				</div>
				<div class="rate_item rate_divider">
					<div class="rate_label">{{$t('loan.interest')}}</div>
					<div class="rate_value">{{ calculatedInterest.toFixed(2) }}</div>
				</div>
				<div class="rate_item">
					<div class="rate_label">{{$t('loan.overdueRate')}}</div>
					<div class="rate_value">{{ config.overdue_rate }}%</div>
				</div>
			</div>

			<!-- 表单区域 -->
			<div class="loan_form">
			<!-- 借款周期 -->
				<div class="form_group">
					<label class="form_label">{{$t('loan.borrowingPeriodDays')}}</label>
					<div class="select_wrapper" @click="showPeriodPicker = true">
						<input type="text" :value="borrowingPeriod" readonly class="form_input">
						<span class="arrow_icon" :class="{ 'arrow_up': showPeriodPicker }">▼</span>
					</div>
					<!-- 周期下拉选择器 -->
					<div class="dropdown_menu" v-if="showPeriodPicker" @click.stop>
						<div 
							v-for="period in periodOptions" 
							:key="period"
							class="dropdown_item"
							:class="{ 'selected': period == borrowingPeriod }"
							@click="selectPeriod(period)"
						>
							{{ period }} {{$t('loan.days')}}
						</div>
					</div>
				</div>

				<!-- 借款金额 -->
				<div class="form_group">
					<label class="form_label">{{$t('loan.borrowingAmountUSDT')}}</label>
					<input 
					type="number" 
						v-model="borrowingAmount"
						class="form_input"
						placeholder="1000"
						@input="calculateInterest"
					>
				</div>

				<!-- 提交按钮 -->
				<button 
					class="submit_button" 
					@click="handleSubmit"
					:class="{ 'disabled': isSubmitting }"
					:disabled="isSubmitting"
				>
					{{ isSubmitting ? $t('loan.submitting') : $t('loan.submit') }}
				</button>

				<!-- 协议复选框 -->
				<div class="agreement_box">
					<input 
						type="checkbox" 
						id="agree_terms" 
						v-model="agreedToTerms"
						class="checkbox_input"
					>
					<label for="agree_terms" class="checkbox_label">
						{{$t('loan.agreeToTerms')}}
						<span class="agreement_link" @click.prevent="showAgreement = true">
							{{$t('loan.lendingAgreement')}}
						</span>
					</label>
				</div>
			</div>
		</div>

		<!-- 借贷协议抽屉（底部弹出） -->
		<div class="drawer_overlay" v-if="showAgreement" @click="showAgreement = false">
			<div class="drawer_content" @click.stop :class="{ 'drawer_open': showAgreement }">
				<div class="drawer_header">
					<div class="drawer_handle"></div>
					<h2>{{$t('loan.lendingAgreement')}}</h2>
					<div class="close_btn" @click="showAgreement = false">×</div>
				</div>
				<div class="drawer_body">
					<div class="agreement_content" v-if="agreementContent" v-html="agreementContent"></div>
					<div class="agreement_content" v-else>
						<p style="text-align: center; color: #999; padding: 40px 0;">加載中...</p>
					</div>
				</div>
			</div>
		</div>

		<!-- 借贷记录侧边栏 -->
		<div class="modal_overlay records_overlay" v-if="showRecords" @click="showRecords = false">
			<div class="modal_sidebar records_sidebar" @click.stop>
				<!-- 电路板背景 -->
				<div class="circuit_background records_bg">
					<svg xmlns="http://www.w3.org/2000/svg">
						<defs>
							<pattern id="circuit-records" x="0" y="0" width="200" height="200" patternUnits="userSpaceOnUse">
								<line x1="0" y1="50" x2="80" y2="50" stroke="#00d9ff" stroke-width="2"/>
								<line x1="120" y1="50" x2="200" y2="50" stroke="#00d9ff" stroke-width="2"/>
								<circle cx="80" cy="50" r="4" fill="#00d9ff"/>
								<circle cx="120" cy="50" r="4" fill="#00d9ff"/>
								<line x1="50" y1="0" x2="50" y2="80" stroke="#00d9ff" stroke-width="2"/>
								<line x1="50" y1="120" x2="50" y2="200" stroke="#00d9ff" stroke-width="2"/>
								<circle cx="50" cy="80" r="4" fill="#00d9ff"/>
								<circle cx="50" cy="120" r="4" fill="#00d9ff"/>
								<line x1="150" y1="0" x2="150" y2="150" stroke="#00d9ff" stroke-width="2"/>
								<line x1="150" y1="150" x2="200" y2="150" stroke="#00d9ff" stroke-width="2"/>
								<circle cx="150" cy="150" r="4" fill="#00d9ff"/>
								<circle cx="100" cy="100" r="6" fill="none" stroke="#00d9ff" stroke-width="2"/>
								<circle cx="100" cy="100" r="3" fill="#00d9ff"/>
							</pattern>
						</defs>
						<rect width="100%" height="100%" fill="url(#circuit-records)"/>
					</svg>
				</div>

				<div class="sidebar_content">
					<div class="sidebar_header">
						<div class="back_btn" @click="showRecords = false">
							<img src="../../assets/images/return-w.png" alt="">
						</div>
						<h2>{{$t('loan.loanRecord')}}</h2>
					</div>

				<!-- 标签栏 -->
				<div class="tabs_wrapper">
					<div 
						v-for="tab in tabs" 
						:key="tab.value"
						class="tab_item"
						:class="{ 'active': activeTab === tab.value }"
						@click="activeTab = tab.value"
					>
						{{ tab.label }}
					</div>
				</div>
		
				<!-- 记录列表 -->
				<div class="records_list">
					<div 
						v-for="record in filteredRecords" 
						:key="record.id"
						class="record_card"
						@click="showRecordDetail(record)"
					>
						<div class="record_header">
							<div class="record_date">{{ formatDateTime(record.apply_time) }}</div>
							<div class="record_status" :class="'status_' + record.status">
								{{ getStatusLabel(record.status) }}
						</div>
					</div>
						<div class="record_body">
							<div class="record_info">
								<div class="info_label">{{$t('loan.loanAmountUSDT')}}</div>
								<div class="info_value">{{ record.amount }}</div>
							</div>
							<div class="record_info">
								<div class="info_label">{{$t('loan.repaymentCycle')}}</div>
								<div class="info_value">{{ record.period }} {{$t('loan.days')}}</div>
							</div>
							<div class="record_info">
								<div class="info_label">{{$t('loan.dailyRate')}}</div>
								<div class="info_value">{{ record.daily_rate }}%</div>
							</div>
						</div>
						<!-- 待还款和已逾期状态显示还款按钮 -->
						<div class="record_actions" v-if="record.status === 1 || record.status === 5" @click.stop>
							<button class="btn_repay" @click="showRepayConfirm(record)">{{$t('loan.repayButton')}}</button>
						</div>
					</div>

					<div v-if="filteredRecords.length === 0" class="empty_state">
						{{$t('loan.noRecord')}}
					</div>

					<div v-if="filteredRecords.length > 0" class="list_footer">
						{{$t('loan.noMoreRecords')}}
					</div>
				</div>
			</div>
		</div>
	</div>

		<!-- 记录详情底部抽屉 -->
		<div class="detail_drawer_overlay" v-if="showDetail" @click="showDetail = false">
			<div class="detail_drawer" @click.stop :class="{ 'drawer_open': showDetail }">
				<div class="drawer_handle" @click="showDetail = false"></div>
				
				<div class="detail_header">
					<h3>{{$t('loan.currentStatus')}}</h3>
					<div class="detail_status" :class="'status_' + selectedRecord.status">
						{{ getStatusLabel(selectedRecord.status) }}
					</div>
					<button class="close_drawer" @click="showDetail = false">×</button>
				</div>

				<div class="detail_content">
					<!-- 贷款信息卡片 -->
					<div class="info_card">
						<div class="card_row">
							<span class="row_label">{{$t('loan.loanAmount2')}}</span>
							<span class="row_value">{{ selectedRecord.amount }} USDT</span>
						</div>
						<div class="card_row">
							<span class="row_label">{{$t('loan.repaymentCycle')}}：</span>
							<span class="row_value">{{ selectedRecord.period }} {{$t('loan.days')}}</span>
						</div>
						<div class="card_row">
							<span class="row_label">{{$t('loan.dailyRate2')}}</span>
							<span class="row_value">{{ selectedRecord.daily_rate }} %</span>
						</div>
						<div class="card_row" v-if="selectedRecord.due_date">
							<span class="row_label">{{$t('loan.dueDate')}}：</span>
							<span class="row_value">{{ formatDateTime(selectedRecord.due_date) }}</span>
						</div>
					</div>

					<!-- 逾期信息卡片 (status=5已逾期 或 有逾期天数) -->
					<div class="overdue_card" v-if="selectedRecord.status === 5 || (selectedRecord.overdue_days && selectedRecord.overdue_days > 0)">
						<div class="overdue_title">{{$t('loan.overdueInfo')}}</div>
						<div class="card_row">
							<span class="row_label">{{$t('loan.overdueDays')}}</span>
							<span class="row_value overdue_text">{{ selectedRecord.overdue_days || 0 }} {{$t('loan.days')}}</span>
						</div>
						<div class="card_row">
							<span class="row_label">{{$t('loan.overdueFee')}}：</span>
							<span class="row_value overdue_text">{{ (selectedRecord.overdue_fee || 0).toFixed(2) }} USDT</span>
						</div>
						<div class="card_row highlight">
							<span class="row_label">{{$t('loan.totalRepayWithFee')}}：</span>
							<span class="row_value">{{ ((selectedRecord.total_repay || 0) + (selectedRecord.overdue_fee || 0)).toFixed(2) }} USDT</span>
						</div>
					</div>

					<!-- 拒绝原因卡片 (status=4) -->
					<div class="refuse_card" v-if="selectedRecord.status === 4 && selectedRecord.refuse_reason">
						<div class="refuse_title">{{$t('loan.refuseReason')}}</div>
						<div class="refuse_text">{{ selectedRecord.refuse_reason }}</div>
					</div>

					<!-- 还款信息卡片 (status=1待还款 或 status=2已还待确认 或 status=3已结清 或 status=5已逾期) -->
					<div class="repay_card" v-if="selectedRecord.status === 1 || selectedRecord.status === 2 || selectedRecord.status === 3 || selectedRecord.status === 5">
						<div class="repay_title">{{$t('loan.repaymentInfo')}}</div>
						<div class="card_row highlight">
							<span class="row_label">{{$t('loan.totalRepay')}}</span>
							<span class="row_value">
								{{ selectedRecord.overdue_fee && selectedRecord.overdue_fee > 0 
									? ((selectedRecord.total_repay || 0) + (selectedRecord.overdue_fee || 0)).toFixed(2) 
									: selectedRecord.total_repay 
								}} USDT
							</span>
						</div>
						<div class="card_row" v-if="selectedRecord.repay_time">
							<span class="row_label">{{$t('loan.repayTime')}}</span>
							<span class="row_value">{{ formatDateTime(selectedRecord.repay_time) }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 底部导航栏 -->
		<FooterTab :activeType="'loan'" />
  </div>
</template>

<script>
import FooterTab from '../../components/FooterTab.vue'
import Fetch from '../../utils/fetch'

export default {
  name: 'Loan',
	components: { FooterTab },
  data() {
    return {
			// 配置信息
			config: {
				daily_rate: 0.18,
				overdue_rate: 0.10,
				min_amount: 100,
				max_amount: 50000,
				product_id: null
			},
			periodOptions: [7, 14, 30, 60, 90],
			periodMap: {}, // 期限到产品配置的映射
			loanData: null, // 保存完整的贷款数据
			// 表单数据
			borrowingPeriod: '30',
			borrowingAmount: '', // 默认为空，让用户自己输入
			agreedToTerms: false,
			calculatedInterest: 0,
		// 界面状态
		showPeriodPicker: false,
		showAgreement: false,
		showRecords: false,
		isSubmitting: false,
		showDetail: false,
		// 记录数据
		loanRecords: [],
		activeTab: 'all',
		tabs: [
			{ label: '全部', value: 'all' }
		],
		selectedRecord: {},
		// 协议内容
		agreementContent: '',
		agreementLoading: false
		};
	},
	computed: {
		filteredRecords() {
			if (this.activeTab === 'all') {
				return this.loanRecords;
			}
			const statusMap = {
				'reviewing': [0], // 待审批
				'repaying': [1], // 待还款
				'confirmed': [2], // 已还待确认
				'completed': [3], // 已结清
				'overdue': [5], // {{$t('loan.statusOverdue')}}
				'rejected': [4] // 已拒绝
			};
			const statuses = statusMap[this.activeTab] || [];
			return this.loanRecords.filter(record => statuses.includes(record.status));
		}
	},
	watch: {
		// 监听贷款记录侧边栏的显示状态
		showRecords(newVal) {
			if (newVal) {
				// 打开贷款记录时自动刷新订单状态
				this.loadLoanRecords();
			}
		}
	},
	created() {
		this.$parent.footer("user", false);
		// 动态生成 tabs 数组（使用 $t() 方法）
		this.tabs = [
			{ label: this.$t('loan.all'), value: 'all' },
			{ label: this.$t('loan.statusReviewing'), value: 'reviewing' },
			{ label: this.$t('loan.statusRepaying'), value: 'repaying' },
			{ label: this.$t('loan.statusConfirming'), value: 'confirmed' },
			{ label: this.$t('loan.statusCompleted'), value: 'completed' },
			{ label: this.$t('loan.statusOverdue'), value: 'overdue' },
			{ label: this.$t('loan.statusRejected'), value: 'rejected' }
		];
		this.loadConfig();
		this.calculateInterest();
		this.loadLoanRecords();
		this.loadAgreement();
  },
  methods: {
    goBack() {
			this.$router.push('/userCenter');
    },
    
		// 加载配置
		async loadConfig() {
       try {
				const result = await Fetch('/user/loan_config');
         if (result && result.code === 1 && result.data) {
					// 保存原始数据
					this.loanData = result.data;
					
					// 设置配置（兼容旧格式）
					this.config = {
						daily_rate: result.data.daily_rate || 0.18,
						overdue_rate: result.data.overdue_rate || 0.10,
						min_amount: result.data.min_amount || 100,
						max_amount: result.data.max_amount || 50000,
						product_id: result.data.product_id
					};
					
					// 设置周期选项
					this.periodOptions = Array.isArray(result.data.periods) ? result.data.periods : [7, 14, 30, 60, 90];
					
					// 保存期限映射关系（用于切换天数时更新配置）
					this.periodMap = result.data.period_map || {};
					
					// 设置默认周期为第一个可用选项
					if (this.periodOptions.length > 0) {
						this.borrowingPeriod = this.periodOptions[0].toString();
					}
					
					this.calculateInterest();
       }
     } catch (error) {
			console.error(this.$t('loan.loadingConfig'), error);
		}
	},

		// 选择周期
		selectPeriod(period) {
			this.borrowingPeriod = period.toString();
			this.showPeriodPicker = false;
			
			// 根据选择的天数更新产品配置
			if (this.periodMap && this.periodMap[period]) {
				const periodConfig = this.periodMap[period];
				this.config.daily_rate = periodConfig.rate;
				this.config.overdue_rate = periodConfig.overdue_rate;
				this.config.min_amount = periodConfig.min_amount;
				this.config.max_amount = periodConfig.max_amount;
				this.config.product_id = periodConfig.product_id;
			}
			
			this.calculateInterest();
		},

		// 计算利息
    calculateInterest() {
			const amount = parseFloat(this.borrowingAmount) || 0;
			const period = parseInt(this.borrowingPeriod) || 0;
			const rate = parseFloat(this.config.daily_rate) || 0;
			this.calculatedInterest = amount * (rate / 100) * period;
		},

	// 提交申请
	async handleSubmit() {
		if (this.isSubmitting) {
			this.showToastMessage(this.$t('loan.submitting'), false);
			return;
		}

		if (!this.agreedToTerms) {
			this.showToastMessage(this.$t('loan.pleaseAgreeToTerms'), false);
			return;
		}

		const amount = parseFloat(this.borrowingAmount);
		if (!amount || amount <= 0) {
			this.showToastMessage(this.$t('loan.pleaseEnterValidAmount'), false);
			return;
		}

		if (amount < this.config.min_amount) {
			this.showToastMessage(`${this.$t('loan.minAmountIs')} $${this.config.min_amount}`, false);
			return;
		}

		if (amount > this.config.max_amount) {
			this.showToastMessage(`${this.$t('loan.maxAmountIs')} $${this.config.max_amount}`, false);
      return;
    }

			this.isSubmitting = true;

			try {
				const result = await Fetch('/user/loan_apply', {
					product_id: this.config.product_id, // 添加产品ID
					amount: amount,
					period: parseInt(this.borrowingPeriod),
					daily_rate: this.config.daily_rate,
					overdue_rate: this.config.overdue_rate,
					interest: this.calculatedInterest,
					total_repay: amount + this.calculatedInterest
				});

	if (result && result.code === 1) {
		// 使用绿色 toast 提示成功
		this.showToastMessage(this.$t('loan.applicationSuccess'), true);
		
		// 清空表单
		this.borrowingAmount = ''; // 清空金额，让用户重新输入
		this.borrowingPeriod = '30';
		this.agreedToTerms = false;
		this.calculateInterest();
		
		// 刷新记录并打开贷款记录侧边栏
		this.loadLoanRecords();
		
		// 延迟打开侧边栏，让用户看到成功提示
		setTimeout(() => {
			this.showRecords = true;
		}, 500);
	} else {
				// 检查是否是特定的错误代码
				let errorMessage = result.info || '申请失败';
				
				// 如果是错误代码，显示对应语言的消息
				if (errorMessage === 'HAS_ONGOING_LOAN') {
					errorMessage = this.$t('loan.hasOngoingLoan') || '您有正在进行中的贷款，请先处理完成后再申请';
				} else if (errorMessage === 'HAS_OVERDUE_LOAN') {
					errorMessage = this.$t('loan.hasOverdueLoan') || '您有逾期未还款的贷款，请先还款后再申请';
				} else if (errorMessage === 'HAS_PENDING_CONFIRM') {
					errorMessage = this.$t('loan.hasPendingConfirm') || '您有还款待确认的贷款，请等待管理员确认后再申请';
				}
				
				// 使用自定义 toast 显示错误信息
				this.showToastMessage(errorMessage, false);
			}
		} catch (error) {
			console.error('提交申请失败:', error);
		} finally {
			this.isSubmitting = false;
		}
	},


		// 加载借贷记录
		async loadLoanRecords() {
			try {
				const result = await Fetch('/user/loan_list');
				if (result && result.code === 1 && result.data) {
					this.loanRecords = result.data.list || [];
				}
			} catch (error) {
				console.error('加载记录失败:', error);
			}
		},

	// 获取状态标签
	getStatusLabel(status) {
		const statusMap = {
			0: this.$t('loan.statusReviewing'),
			1: this.$t('loan.statusRepaying'),
			2: this.$t('loan.statusConfirming'),
			3: this.$t('loan.statusCompleted'),
			4: this.$t('loan.statusRejected'),
			5: this.$t('loan.statusOverdue')
		};
		return statusMap[status] || '未知';
	},

	// 显示记录详情
	showRecordDetail(record) {
		this.selectedRecord = record;
		this.showDetail = true;
	},

	// 计算逾期天数
	calculateOverdueDays(record) {
		if (!record.repay_time) return 0;
		const now = new Date();
		const repayDate = new Date(record.repay_time);
		const diffTime = now - repayDate;
		const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
		return diffDays > 0 ? diffDays : 0;
	},

	// 显示还款确认
	showRepayConfirm(record) {
		console.log('showRepayConfirm 被调用', record);
		
		// 计算实际应还总额（含违约金）
		// 如果有逾期费，应还总额 = 本金 + 利息 + 违约金
		const actualRepayAmount = (record.overdue_fee && record.overdue_fee > 0) 
			? ((parseFloat(record.total_repay) || 0) + (parseFloat(record.overdue_fee) || 0)).toFixed(2)
			: (parseFloat(record.total_repay) || 0).toFixed(2);
		
		// 创建还款确认弹窗
		const overlay = document.createElement('div');
		overlay.className = 'repay_confirm_overlay';
		overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:10000;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity 0.3s ease;';
		
		const dialog = document.createElement('div');
		dialog.className = 'repay_confirm_dialog';
		dialog.style.cssText = 'background:#ffffff;border-radius:16px;width:100%;max-width:320px;box-shadow:0 8px 32px rgba(0,0,0,0.2);transform:translateY(-20px) scale(0.95);opacity:0;transition:all 0.3s cubic-bezier(0.32,0.72,0,1);overflow:hidden;';
		
		dialog.innerHTML = `
			<div class="repay_confirm_header" style="padding:20px;border-bottom:1px solid #F0F0F0;text-align:center;background:#ffffff;">
				<h3 style="margin:0;font-size:18px;font-weight:600;color:#333333;">${this.$t('loan.repayTitle')}</h3>
			</div>
			<div class="repay_confirm_body" style="padding:24px 20px;text-align:center;background:#ffffff;">
				<p class="repay_tip" style="font-size:16px;color:#666666;margin:0;line-height:1.5;">${this.$t('loan.totalRepayAmount')} <span style="color:#1677FF;font-weight:600;font-size:18px;">${actualRepayAmount} USDT</span></p>
			</div>
			<div class="repay_confirm_footer" style="display:flex;border-top:1px solid #F0F0F0;background:#ffffff;">
				<button class="btn_cancel" style="flex:1;height:48px;border:none;background:none;font-size:16px;cursor:pointer;transition:background 0.3s ease;color:#666666;border-right:1px solid #F0F0F0;">${this.$t('utils.cancel')}</button>
				<button class="btn_confirm" style="flex:1;height:48px;border:none;background:none;font-size:16px;cursor:pointer;transition:background 0.3s ease;color:#1677FF;font-weight:500;">${this.$t('utils.confirm')}</button>
			</div>
		`;
		
		overlay.appendChild(dialog);
		document.body.appendChild(overlay);
		
		console.log('弹窗已添加到DOM', overlay);
		
		// 触发动画
		setTimeout(() => {
			overlay.style.opacity = '1';
			dialog.style.transform = 'translateY(0) scale(1)';
			dialog.style.opacity = '1';
			overlay.classList.add('show');
			console.log('动画已触发');
		}, 10);
		
		// 绑定事件
		const btnCancel = dialog.querySelector('.btn_cancel');
		const btnConfirm = dialog.querySelector('.btn_confirm');
		
		// 添加悬停效果
		btnCancel.onmouseenter = () => btnCancel.style.background = '#F5F5F5';
		btnCancel.onmouseleave = () => btnCancel.style.background = 'none';
		btnConfirm.onmouseenter = () => btnConfirm.style.background = '#F0F7FF';
		btnConfirm.onmouseleave = () => btnConfirm.style.background = 'none';
		
		const closeDialog = () => {
			overlay.style.opacity = '0';
			dialog.style.transform = 'translateY(-20px) scale(0.95)';
			dialog.style.opacity = '0';
			overlay.classList.remove('show');
			setTimeout(() => {
				if (overlay.parentNode) {
					document.body.removeChild(overlay);
				}
			}, 300);
		};
		
		btnCancel.onclick = closeDialog;
		btnConfirm.onclick = async () => {
			closeDialog();
			await this.handleRepay(record);
		};
		overlay.onclick = (e) => {
			if (e.target === overlay) {
				closeDialog();
			}
		};
	},

	// 处理还款
	async handleRepay(record) {
		try {
			const result = await Fetch('/user/loan_repay', {
				loan_id: record.id,
				amount: record.total_repay
			});
			
			if (result && result.code === 1) {
				this.showToastMessage(this.$t('loan.repaySuccess2'), true);
				
				// 刷新记录
				this.loadLoanRecords();
			} else {
				this.showToastMessage(result.info || this.$t('loan.repayFailed2'), false);
			}
      } catch (error) {
			console.error('还款失败:', error);
			this.showToastMessage(this.$t('loan.repayError'), false);
		}
	},

		// 格式化日期时间
		formatDateTime(datetime) {
			if (!datetime) return '';
			const date = new Date(datetime);
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			return `${month}/${day} ${hours}:${minutes}`;
		},

		// 显示简单的提示消息
		showToastMessage(message, isSuccess = true) {
			const toast = document.createElement('div');
			toast.className = 'simple_toast';
			toast.style.cssText = `
				position: fixed;
				top: 80px;
				left: 50%;
				transform: translateX(-50%) translateY(-100px);
				background: ${isSuccess ? '#52C41A' : '#FF4D4F'};
				color: white;
				padding: 12px 24px;
				border-radius: 8px;
				font-size: 14px;
				font-weight: 500;
				z-index: 99999;
				box-shadow: 0 4px 12px rgba(0,0,0,0.15);
				transition: all 0.3s cubic-bezier(0.32, 0.72, 0, 1);
				opacity: 0;
				pointer-events: none;
			`;
			toast.textContent = message;
			document.body.appendChild(toast);
			
			// 触发动画
			setTimeout(() => {
				toast.style.transform = 'translateX(-50%) translateY(0)';
				toast.style.opacity = '1';
			}, 10);
			
			// 2秒后自动消失
			setTimeout(() => {
				toast.style.transform = 'translateX(-50%) translateY(-100px)';
				toast.style.opacity = '0';
				setTimeout(() => {
					if (toast.parentNode) {
						document.body.removeChild(toast);
					}
				}, 300);
			}, 2000);
		},

		// 加载贷款协议
		async loadAgreement() {
			if (this.agreementLoading) return;
			this.agreementLoading = true;
			
			try {
				// 获取当前语言
				const lang = localStorage.getItem('lang') || 'zh_hk';
				
				const result = await Fetch('/user/loan_agreement', { lang: lang });
				if (result && result.code === 1 && result.data) {
					this.agreementContent = result.data.content;
				}
			} catch (error) {
				console.error('加载协议失败:', error);
			} finally {
				this.agreementLoading = false;
			}
		}
	}
};
</script>

<style lang="less" scoped>
.loan_page {
  min-height: 100vh;
	background: linear-gradient(180deg, #1677FF 0%, #E6F0FF 100%);
	position: relative;
	overflow: hidden;
	padding-bottom: 60px;
}

/* 电路板背景 */
.circuit_background {
	position: absolute;
	inset: 0;
	opacity: 0.05;
	pointer-events: none;

	svg {
		width: 100%;
		height: 100%;
	}
}

/* 内容区 */
.loan_content {
    position: relative;
	z-index: 10;
}

/* 头部 */
.loan_header {
    display: flex;
    align-items: center;
	justify-content: space-between;
	padding: 16px;

	.header_left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	h1 {
		color: #ffffff;
		font-size: 18px;
        font-weight: 500;
		margin: 0;
    }

	.back_btn {
		padding: 4px;
        cursor: pointer;
		transition: background-color 0.2s;
		border-radius: 4px;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
		}

		img {
			width: 24px;
			height: 24px;
			display: block;
		}
	}

	.menu_btn {
		padding: 4px;
		cursor: pointer;
		transition: background-color 0.2s;
		border-radius: 4px;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
		}

		.menu_icon {
  display: flex;
			flex-direction: column;
			gap: 4px;
			width: 24px;

			span {
				display: block;
				height: 2px;
				background: #ffffff;
				border-radius: 1px;
			}
		}
	}
}

/* 利率信息卡片 */
.rate_card {
	margin: 32px 16px;
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 16px;
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(10px);
	border-radius: 16px;
	padding: 20px 16px;
	border: none;
	box-shadow: 0 4px 12px rgba(22, 119, 255, 0.15);

	.rate_item {
  text-align: center;

		&.rate_divider {
			border-left: 1px solid rgba(22, 119, 255, 0.15);
			border-right: 1px solid rgba(22, 119, 255, 0.15);
		}

		.rate_label {
			color: #666666;
			font-size: 13px;
			margin-bottom: 6px;
		}

		.rate_value {
			color: #1677FF;
			font-size: 18px;
  font-weight: 600;
		}
	}
}

/* 表单区域 */
.loan_form {
	padding: 0 16px;

	.form_group {
		margin-bottom: 24px;
		position: relative;

		.form_label {
  display: block;
			color: #333333;
			font-size: 15px;
			margin-bottom: 12px;
  font-weight: 500;
}

		.form_input {
  width: 100%;
  height: 50px;
			background: #ffffff;
			border: 1px solid #D9D9D9;
  border-radius: 8px;
			color: #333333;
  font-size: 16px;
			padding: 0 16px;
			transition: all 0.3s;

			&:hover {
				border-color: #1677FF;
			}

			&:focus {
  outline: none;
				border-color: #1677FF;
				box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
			}

			&::placeholder {
				color: #BFBFBF;
			}
		}

		.select_wrapper {
			position: relative;
			cursor: pointer;

			.arrow_icon {
  position: absolute;
				right: 16px;
  top: 50%;
  transform: translateY(-50%);
				color: #1677FF;
				font-size: 12px;
				transition: transform 0.2s;
  pointer-events: none;

				&.arrow_up {
					transform: translateY(-50%) rotate(180deg);
				}
			}
		}

		.dropdown_menu {
			position: absolute;
			top: calc(100% + 4px);
			left: 0;
			right: 0;
			background: #ffffff;
			border: 1px solid #E6E6E6;
			border-radius: 8px;
			overflow: hidden;
			z-index: 100;
			max-height: 240px;
			overflow-y: auto;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

			.dropdown_item {
				padding: 14px 16px;
				color: #333333;
				cursor: pointer;
				transition: background-color 0.2s;

				&:hover {
					background: #F5F8FF;
				}

				&.selected {
					background: #E6F0FF;
					color: #1677FF;
					font-weight: 500;
				}
			}
		}
	}

	.submit_button {
		width: 100%;
		height: 50px;
		background: linear-gradient(135deg, #1677FF 0%, #4096FF 100%);
		color: #ffffff;
		font-size: 16px;
		font-weight: 600;
		border: none;
		border-radius: 25px;
		cursor: pointer;
		margin-top: 32px;
		transition: all 0.3s;
		box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);

		&:hover:not(.disabled) {
			background: linear-gradient(135deg, #0958D9 0%, #1677FF 100%);
			transform: translateY(-2px);
			box-shadow: 0 6px 16px rgba(22, 119, 255, 0.4);
		}

		&:active:not(.disabled) {
			transform: translateY(0);
		}

		&.disabled {
			background: #D9D9D9;
			cursor: not-allowed;
			opacity: 0.6;
			box-shadow: none;
		}
	}

	.agreement_box {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		margin-top: 24px;

		.checkbox_input {
			margin-top: 4px;
			width: 16px;
			height: 16px;
			cursor: pointer;
			accent-color: #1677FF;
		}

		.checkbox_label {
			flex: 1;
			color: #666666;
			font-size: 14px;
			line-height: 1.5;
			cursor: pointer;

			.agreement_link {
				color: #1677FF;
				text-decoration: underline;
				cursor: pointer;

				&:hover {
					color: #0958D9;
				}
			}
		}
	}
}

/* 模态框 */
.modal_overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.6);
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;

	&.records_overlay {
		align-items: stretch;
		justify-content: flex-end;
	}
}

.modal_content {
	background: #ffffff;
	width: 90%;
	max-width: 600px;
	max-height: 90vh;
	border-radius: 16px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

	&.agreement_modal {
		max-height: 95vh;
	}
}

.modal_sidebar {
	background: linear-gradient(180deg, #E6F4FF 0%, #F0F8FF 100%);
	width: 100%;
	max-width: 400px;
	height: 100vh;
	display: flex;
	flex-direction: column;
	position: relative;
	box-shadow: -4px 0 12px rgba(22, 119, 255, 0.15);
}

.modal_sidebar .circuit_background {
	opacity: 0.03;
}

.modal_header,
.sidebar_header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 16px;
	border-bottom: 1px solid rgba(22, 119, 255, 0.15);
	position: relative;
	z-index: 10;
	background: rgba(255, 255, 255, 0.8);
	backdrop-filter: blur(10px);
}

.sidebar_header h2 {
	color: #1677FF;
	font-size: 18px;
	font-weight: 600;
	margin: 0;
}

.sidebar_header .back_btn {
	padding: 8px;
	cursor: pointer;
	transition: all 0.2s;
  border-radius: 8px;
	background: rgba(22, 119, 255, 0.1);
	display: flex;
	align-items: center;
	justify-content: center;
}

.sidebar_header .back_btn:hover {
	background: rgba(22, 119, 255, 0.2);
}

.sidebar_header .back_btn img {
	width: 20px;
	height: 20px;
	display: block;
	filter: brightness(0) saturate(100%) invert(42%) sepia(93%) saturate(1352%) hue-rotate(191deg) brightness(99%) contrast(101%);
}

.modal_body {
	flex: 1;
	overflow-y: auto;
	padding: 24px;
	background: #ffffff;

	.agreement_content {
		color: #333333;
		line-height: 1.8;

		h1 {
			color: #1677FF;
			font-size: 18px;
			margin: 32px 0 16px;
			font-weight: 600;

			&:first-child {
				margin-top: 0;
			}
		}

		h2 {
			color: #1677FF;
  font-size: 16px;
			margin: 24px 0 12px;
			font-weight: 600;
		}

		p {
			margin-bottom: 16px;
			color: #666666;
		}

		.update_date {
			margin-top: 32px;
			margin-bottom: 48px;
			color: #999999;
		}
	}
}

.sidebar_content {
	flex: 1;
	display: flex;
	flex-direction: column;
	position: relative;
	z-index: 10;
	overflow: hidden; /* 添加：防止内容溢出 */
	min-height: 0; /* 添加：确保flex子元素可以正确收缩 */
}

/* 标签栏 */
.tabs_wrapper {
	display: flex;
	border-bottom: 1px solid #F0F0F0;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	background: #ffffff;

	&::-webkit-scrollbar {
		display: none;
	}

	.tab_item {
		flex-shrink: 0;
		padding: 12px 16px;
		color: #666666;
		font-size: 14px;
		cursor: pointer;
		position: relative;
		transition: color 0.2s;
		white-space: nowrap;

		&.active {
			color: #1677FF;
			font-weight: 600;

			&::after {
				content: '';
  position: absolute;
				bottom: 0;
				left: 0;
				right: 0;
				height: 2px;
				background: #1677FF;
			}
		}
	}
}

/* 记录列表 */
.records_list {
	flex: 1;
	overflow-y: auto;
	padding: 16px;
	background: #F5F5F5;
	min-height: 0; /* 添加：确保在flex容器中可以正确滚动 */
	-webkit-overflow-scrolling: touch; /* 添加：iOS平滑滚动 */

	.record_card {
		background: #ffffff;
		backdrop-filter: blur(10px);
		border-radius: 12px;
		padding: 16px;
		border: none;
		margin-bottom: 12px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

		.record_header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 16px;

			.record_date {
				color: #999999;
				font-size: 13px;
			}

			.record_status {
				padding: 4px 12px;
				border-radius: 12px;
  font-size: 12px;
				border: none;
				font-weight: 500;

				&.status_0 {
					background: #FFF7E6;
					color: #FA8C16;
				}

				&.status_1 {
					background: #E6F0FF;
					color: #1677FF;
				}

				&.status_2 {
					background: #E6FFFB;
					color: #13C2C2;
				}

				&.status_3 {
					background: #F6FFED;
					color: #52C41A;
				}

				&.status_4 {
					background: #FFF1F0;
					color: #FF4D4F;
				}

				&.status_5 {
					background: #FFF2E8;
					color: #FA541C;
				}
			}
		}

		.record_body {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;

			.record_info {
				.info_label {
					color: #999999;
					font-size: 12px;
					margin-bottom: 4px;
				}

				.info_value {
					color: #333333;
					font-size: 14px;
					font-weight: 500;
				}
			}
		}

		.record_actions {
			margin-top: 16px;
			padding-top: 16px;
			border-top: 1px solid #F0F0F0;
  display: flex;
			justify-content: center;

			.btn_repay {
				padding: 8px 40px;
				background: linear-gradient(135deg, #1890FF 0%, #1677FF 100%);
				color: #ffffff;
				border: none;
				border-radius: 20px;
				font-size: 14px;
				font-weight: 500;
  cursor: pointer;
				transition: all 0.3s ease;

				&:hover {
					box-shadow: 0 4px 12px rgba(22, 119, 255, 0.3);
					transform: translateY(-2px);
				}

				&:active {
					transform: translateY(0);
				}
			}
		}

		.record_footer {
			margin-top: 16px;
			padding-top: 16px;
			border-top: 1px solid #F0F0F0;

			.refuse_reason {
				color: #FF4D4F;
				font-size: 12px;
				line-height: 1.5;
			}
		}
	}

	.empty_state {
		text-align: center;
		color: #BFBFBF;
		padding: 48px 0;
		font-size: 14px;
	}

	.list_footer {
		text-align: center;
		color: #BFBFBF;
		padding: 32px 0;
		font-size: 12px;
		border-top: 1px solid #F0F0F0;
	}
}

/* 底部抽屉样式 */
.drawer_overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 9999;
	animation: fadeIn 0.3s ease;
}

.drawer_content {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	max-height: 80vh;
	background: #ffffff;
	border-radius: 24px 24px 0 0;
	transform: translateY(100%);
	transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
	display: flex;
	flex-direction: column;
	box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.2);

	&.drawer_open {
		transform: translateY(0);
	}
}

.drawer_header {
  position: relative;
	padding: 16px 20px;
	border-bottom: 1px solid #F0F0F0;
  flex-shrink: 0;

	.drawer_handle {
		width: 40px;
		height: 4px;
		background: #D9D9D9;
		border-radius: 2px;
		margin: 0 auto 12px;
		cursor: grab;
	}

	h2 {
		font-size: 18px;
		font-weight: 600;
		color: #1677FF;
		text-align: center;
		margin: 0;
	}

	.close_btn {
  position: absolute;
		top: 16px;
		right: 20px;
		width: 32px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		color: #999999;
		cursor: pointer;
		transition: all 0.3s;

		&:hover {
			color: #333333;
			background: #F5F5F5;
			border-radius: 50%;
		}
	}
}

.drawer_body {
	flex: 1;
	overflow-y: auto;
	padding: 20px;
	-webkit-overflow-scrolling: touch;

	/* 自定义滚动条 */
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-thumb {
		background: #D9D9D9;
		border-radius: 3px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

/* 提交成功弹窗样式 */
.success_overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.6);
	z-index: 10000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	opacity: 1; /* 直接显示，v-if 已经控制显示/隐藏 */
	animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes slideUp {
	from {
		transform: translateY(30px) scale(0.95);
		opacity: 0;
	}
	to {
		transform: translateY(0) scale(1);
		opacity: 1;
	}
}

.success_dialog {
	background: #ffffff;
	border-radius: 20px;
	width: 100%;
	max-width: 420px;
	box-shadow: 0 12px 48px rgba(0, 0, 0, 0.2);
	transform: translateY(0) scale(1); /* 直接显示，不需要过渡动画 */
	opacity: 1; /* 直接显示 */
	animation: slideUp 0.4s cubic-bezier(0.32, 0.72, 0, 1);
	padding: 32px 24px 24px;
	text-align: center;

	.success_icon {
		margin-bottom: 20px;
		animation: successPop 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.2s both;

		svg {
			display: block;
			margin: 0 auto;
			filter: drop-shadow(0 4px 12px rgba(82, 196, 26, 0.3));
		}
	}

	.success_title {
		font-size: 22px;
		font-weight: 600;
		color: #52C41A;
		margin-bottom: 12px;
		letter-spacing: 0.5px;
	}

	.success_message {
  font-size: 14px;
		color: #666666;
		margin-bottom: 24px;
		line-height: 1.6;
	}

	.success_info {
		background: linear-gradient(135deg, #F6FFED 0%, #FCFFE6 100%);
		border-radius: 12px;
		padding: 16px;
		margin-bottom: 20px;
		border: 1px solid #D9F7BE;

		.info_item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 10px 0;
			font-size: 14px;

			&:not(:last-child) {
				border-bottom: 1px dashed rgba(82, 196, 26, 0.15);
			}

			.info_label {
				color: #8C8C8C;
				font-size: 13px;
			}

			.info_value {
				color: #262626;
				font-weight: 600;
				font-size: 15px;

				&.highlight {
					color: #52C41A;
					font-size: 16px;
				}
			}
		}
	}

	.success_tips {
		background: #FFFBE6;
		border-radius: 8px;
		padding: 12px 16px;
		margin-bottom: 24px;
		border: 1px solid #FFE58F;

		.tip_item {
			display: flex;
			align-items: center;
			padding: 6px 0;
			font-size: 13px;
			color: #8C6E00;

			.tip_icon {
				font-size: 16px;
				margin-right: 8px;
			}

			.tip_text {
				flex: 1;
				text-align: left;
			}
		}
	}

	.btn_confirm_success {
  width: 100%;
		height: 48px;
		background: linear-gradient(135deg, #73D13D 0%, #52C41A 100%);
		color: #ffffff;
  border: none;
		border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
		box-shadow: 0 4px 16px rgba(82, 196, 26, 0.3);
  transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 6px 20px rgba(82, 196, 26, 0.4);
  transform: translateY(-2px);
		}

		&:active {
			transform: translateY(0) scale(0.98);
		}
	}
}

@keyframes successPop {
	0% {
		transform: scale(0);
		opacity: 0;
	}
	50% {
		transform: scale(1.1);
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

/* 还款确认弹窗样式 */
.repay_confirm_overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 10000;
  display: flex;
  align-items: center;
	justify-content: center;
	padding: 20px;
	opacity: 0;
	transition: opacity 0.3s ease;
}

.repay_confirm_overlay.show {
	opacity: 1;
}

.repay_confirm_overlay.show .repay_confirm_dialog {
	transform: translateY(0) scale(1);
	opacity: 1;
}

.repay_confirm_dialog {
	background: #ffffff;
	border-radius: 16px;
	width: 100%;
	max-width: 320px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
	transform: translateY(-20px) scale(0.95);
	opacity: 0;
	transition: all 0.3s cubic-bezier(0.32, 0.72, 0, 1);
}

.repay_confirm_dialog .repay_confirm_header {
	padding: 20px;
	border-bottom: 1px solid #F0F0F0;
	text-align: center;
}

.repay_confirm_dialog .repay_confirm_header h3 {
	margin: 0;
  font-size: 18px;
	font-weight: 600;
	color: #333333;
}

.repay_confirm_dialog .repay_confirm_body {
	padding: 24px 20px;
	text-align: center;
}

.repay_confirm_dialog .repay_confirm_body .repay_tip {
	font-size: 16px;
	color: #666666;
	margin: 0;
}

.repay_confirm_dialog .repay_confirm_footer {
	display: flex;
	border-top: 1px solid #F0F0F0;
}

.repay_confirm_dialog .repay_confirm_footer button {
	flex: 1;
	height: 48px;
	border: none;
	background: none;
	font-size: 16px;
	cursor: pointer;
	transition: background 0.3s ease;
}

.repay_confirm_dialog .repay_confirm_footer button.btn_cancel {
	color: #666666;
	border-right: 1px solid #F0F0F0;
}

.repay_confirm_dialog .repay_confirm_footer button.btn_cancel:hover {
	background: #F5F5F5;
}

.repay_confirm_dialog .repay_confirm_footer button.btn_confirm {
	color: #1677FF;
	font-weight: 500;
}

.repay_confirm_dialog .repay_confirm_footer button.btn_confirm:hover {
	background: #F0F7FF;
}

/* 记录详情底部抽屉样式 */
.detail_drawer_overlay {
  position: fixed;
  top: 0;
  left: 0;
	right: 0;
	bottom: 0;
  background: rgba(0, 0, 0, 0.5);
	z-index: 10001;
	animation: fadeIn 0.3s ease;
}

.detail_drawer {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	max-height: 60vh;
	background: linear-gradient(180deg, #E6F4FF 0%, #F0F8FF 100%);
	border-radius: 24px 24px 0 0;
	transform: translateY(100%);
	transition: transform 0.3s cubic-bezier(0.32, 0.72, 0, 1);
	box-shadow: 0 -8px 32px rgba(22, 119, 255, 0.2);
	overflow: hidden;

	&.drawer_open {
		transform: translateY(0);
	}

	.drawer_handle {
		width: 40px;
		height: 4px;
		background: rgba(22, 119, 255, 0.3);
		border-radius: 2px;
		margin: 12px auto 8px;
		cursor: pointer;
	}

	.detail_header {
		padding: 16px 24px;
		border-bottom: 1px solid rgba(22, 119, 255, 0.15);
  display: flex;
  align-items: center;
		justify-content: space-between;
		position: relative;

		h3 {
			margin: 0;
			font-size: 16px;
			font-weight: 500;
			color: #1677FF;
		}

		.detail_status {
			padding: 4px 12px;
  border-radius: 12px;
			font-size: 13px;
			font-weight: 500;

			&.status_0 {
				background: rgba(250, 140, 22, 0.2);
				color: #FFA940;
			}

			&.status_1 {
				background: rgba(22, 119, 255, 0.2);
				color: #1890FF;
			}

			&.status_2 {
				background: rgba(19, 194, 194, 0.2);
				color: #13C2C2;
			}

			&.status_3 {
				background: rgba(82, 196, 26, 0.2);
				color: #52C41A;
			}

			&.status_4 {
				background: rgba(255, 77, 79, 0.2);
				color: #FF4D4F;
			}

			&.status_5 {
				background: rgba(250, 84, 28, 0.2);
				color: #FA541C;
			}
		}

		.close_drawer {
			position: absolute;
			right: 20px;
			top: -16px;
			width: 32px;
			height: 32px;
			border: none;
			background: rgba(22, 119, 255, 0.1);
			color: #1677FF;
  font-size: 24px;
			line-height: 28px;
			border-radius: 50%;
  cursor: pointer;
			transition: all 0.3s ease;

			&:hover {
				background: rgba(22, 119, 255, 0.2);
			}
		}
	}

	.detail_content {
		padding: 20px 24px;
  overflow-y: auto;
		max-height: calc(60vh - 120px);

		.info_card,
		.refuse_card,
		.repay_card,
		.overdue_card {
			background: #ffffff;
			backdrop-filter: blur(10px);
			border-radius: 12px;
			padding: 16px;
			margin-bottom: 16px;
			border: 1px solid rgba(22, 119, 255, 0.2);

			.card_row {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 8px 0;
				font-size: 14px;

				&:not(:last-child) {
					border-bottom: 1px dashed rgba(22, 119, 255, 0.15);
				}

				.row_label {
					color: #999999;
				}

				.row_value {
					color: #333333;
					font-weight: 500;
				}
				
				.overdue_text {
					color: #FF4D4F;
					font-weight: 600;
				}

				&.highlight {
					.row_label,
					.row_value {
						color: #1677FF;
						font-weight: 600;
						font-size: 16px;
					}
				}
			}
		}

		.overdue_card {
			border-color: rgba(255, 77, 79, 0.3);
			background: #FFF2E8;

			.overdue_title {
				color: #FA541C;
				font-size: 14px;
				font-weight: 500;
				margin-bottom: 8px;
			}
		}

		.refuse_card {
			border-color: rgba(255, 77, 79, 0.3);
			background: #FFF1F0;

			.refuse_title {
				color: #FF4D4F;
  font-size: 14px;
				font-weight: 500;
				margin-bottom: 8px;
			}

			.refuse_text {
				color: #666666;
				font-size: 13px;
  line-height: 1.6;
			}
		}

		.repay_card {
			border-color: rgba(22, 119, 255, 0.3);
			background: #E6F4FF;

			.repay_title {
				color: #1677FF;
				font-size: 14px;
				font-weight: 500;
				margin-bottom: 8px;
			}
		}
	}
}

/* 响应式 */
@media (max-width: 768px) {
	.modal_sidebar {
		max-width: 100%;
	}

	.drawer_content {
		max-height: 90vh;
		border-radius: 20px 20px 0 0;
	}

	.drawer_body {
		padding: 16px;
	}

	.success_dialog {
		max-width: calc(100vw - 40px);
		padding: 28px 20px 20px;

		.success_icon {
			margin-bottom: 16px;

			svg {
				width: 50px;
				height: 50px;
			}
		}

		.success_title {
			font-size: 20px;
		}

		.success_message {
			font-size: 13px;
		}

		.success_info {
			padding: 12px;

			.info_item {
				padding: 8px 0;
				font-size: 13px;

				.info_label {
					font-size: 12px;
				}

				.info_value {
  font-size: 14px;

					&.highlight {
						font-size: 15px;
					}
				}
			}
		}

		.success_tips {
			padding: 10px 12px;

			.tip_item {
				font-size: 12px;

				.tip_icon {
					font-size: 14px;
				}
			}
		}

		.btn_confirm_success {
			height: 44px;
			font-size: 15px;
		}
	}
}
</style>
